export default __webpack_public_path__ + "static/media/bi.5373d97a.png";